// extracted by mini-css-extract-plugin
export default {"container":"AddAziendaNuova_container__fPBlj"};